import { Outlet } from 'react-router-dom';
import { Layout } from 'antd';
import './Dashboard.scss';
import SiderMenu from '../../components/sider/SiderMenu';
import useAuthStore from '../../stores/auth.store';

const DashboardPage = () => {
  const userName = useAuthStore((state) => state.username);
  const email = useAuthStore((state) => state.email);

  return (
    <Layout className={'DashboardPage'}>
      <Layout>
        <SiderMenu email={email} userName={userName} />
        <Layout className={'MainLayout'}>
          <Outlet />
        </Layout>
      </Layout>
    </Layout>
  );
};

export default DashboardPage;
